<div class="password-indicator-container">
  <input
    type="password"
    [formControl]="formControl"
    class="form-control"
    [ngClass]="props.class"
    [formlyAttributes]="field"
    [class.is-invalid]="showError"
    [placeholder]="showSavedIndicator ? '••••••••' : ''" />
  <div class="saved-indicator" *ngIf="showSavedIndicator">
    <i class="fa fa-check-circle"></i>
    <span>Saved</span>
  </div>
</div>
